<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--action_push">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">PUSH</div>
        <div class="workflow-node__title">{{ data?.config?.title || 'Push Notification' }}</div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
